import * as React from 'react';
import qs from 'query-string';
import classNames from 'classnames';
import IntersectionObserver from 'react-intersection-observer';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Icon} from 'components/UIKit';
import * as locales from '../../locales';
import {NavSearchInput} from './NavSearchInput';
import style from './NavSearch.scss';

interface NavSearchProps {
  action: string;
  className?: string;
}

interface NavSearchState {
  term: string;
  showMobileInput: boolean;
}

export class NavSearchComponent extends React.Component<
  NavSearchProps & WithI18nProps,
  NavSearchState
> {
  state: NavSearchState = {
    term: '',
    showMobileInput: false,
  };

  componentDidMount() {
    const queryString = qs.parse(location.search);

    if (queryString && queryString.search) {
      this.setState({term: queryString.search});
    }
  }

  handleButtonVisibilityChange = (inView) => {
    if (this.state.showMobileInput && !inView) {
      this.setState({showMobileInput: false});
    }
  };

  handleCancelSearch = () => this.setState({showMobileInput: false, term: ''});
  handleMobileIconClick = () => this.setState({showMobileInput: true});

  handleInputChange = (event) => {
    this.setState({term: event.target.value});
  };

  render() {
    const {action, className, i18n} = this.props;
    const {term, showMobileInput} = this.state;

    return (
      <IntersectionObserver threshold={1} onChange={this.handleButtonVisibilityChange}>
        {({ref}) => (
          <>
            <NavSearchInput
              value={term}
              action={action}
              onChange={this.handleInputChange}
              onCancel={this.handleCancelSearch}
              className={classNames(style.searchInput, className)}
              placeholder={i18n.translate('search.search')}
              showMobile={showMobileInput}
            />
            <div ref={ref} className={style.deviceButton}>
              <Icon
                icon="search"
                fill="inherit"
                size={20}
                onClick={this.handleMobileIconClick}
                className={classNames(style.deviceIcon, {[style.show]: showMobileInput})}
                asButton
              />
            </div>
          </>
        )}
      </IntersectionObserver>
    );
  }
}

export const NavSearch = withI18n({
  id: 'NavSearch',
  fallback: locales.en,
})(NavSearchComponent);
